<app-header-style-one></app-header-style-one>
<!-- <div *ngFor="let x of jobsScrollData" class="marquee">
    <marquee behavior="" direction="">{{x.message}}.</marquee>
</div> -->
<!-- <div class="marquee">
    <marquee behavior="scroll" direction="left" scrollamount="6">
         <strong>Job Updates:</strong>
        <span *ngFor="let x of jobsScrollData; let last = last">{{ x.message }} <span *ngIf="!last"> | </span>
        </span>
    </marquee>
</div> -->


<!-- <app-homeone-main-banner></app-homeone-main-banner> -->
<!-- <app-about-page-one></app-about-page-one> -->

<div class="page-title-area item-bg1">
    <div class="container">
        <div class="page-title-content">
            <ul>
                <li>&nbsp;</li>
            </ul>
            <h2>&nbsp;</h2>
        </div>
    </div>
</div>

<br>
<div class="container">
    <mat-card class="cardWithShadow theme-card">
        <h3 style="text-align: center;padding: 18px;">Candidate Details</h3>
        <mat-card-content class="b-t-1">
            <form [formGroup]="registrationform" (ngSubmit)="submitRegistrationDetails()" #formContainer>
                <div class="row">
                    <!-- <div class="col-lg-3">
                        <label for="">Are you SHG/SHG Family Member</label>
                        <ng-select (change)="getUlbData($event)" placeholder="Are you SHG/SHG Family Member"
                            formControlName="are_you_shg">
                            <ng-option value="" selected disabled>Are you SHG/SHG Family Member</ng-option>
                             <ng-option value="" selected disabled>SHG Member</ng-option>
                             <ng-option value="" selected disabled>Are you SHG/SHG Family Member</ng-option>
                        </ng-select>
                    </div> -->
                    <div class="col-lg-12">
                        <label> <strong>Are you SHG/SHG Family Member <span
                                    style="color: red;">*</span></strong></label><br>
                        <div style="display: flex;gap: 18px;margin-top: 16px;">
                            <label><input type="radio" formControlName="are_you_shg" value="Yes"> SHG
                                Member</label>
                            <label><input type="radio" formControlName="are_you_shg" value="No"> SHG Family
                                Member</label>
                        </div>

                        <div *ngIf="submittedregist && regist.are_you_shg.errors">
                            <div *ngIf="regist.are_you_shg.errors" class="errormessage"> Please select Are you SHG/SHG
                                Family Member.
                            </div>
                        </div>
                    </div>
                </div>
                <hr>
                <div class="row">
                    <div class="col-lg-3" style="margin-bottom: 18px;">
                        <label for="">Select District <span style="color: red;">*</span></label>
                        <ng-select (change)="getUlbData($event)" placeholder="Select District"
                            formControlName="district_id">
                            <ng-option value="" selected disabled>Select District</ng-option>
                            @for (d of districtData; track d.district_id) {
                            <ng-option [value]="d.district_id">{{ d.district_name }}</ng-option>
                            }
                        </ng-select>
                        <div *ngIf="submittedregist && regist.district_id.errors">
                            <div *ngIf="regist.district_id.errors" class="errormessage"> Please Select District.
                            </div>
                        </div>
                    </div>
                    <div class="col-lg-3" style="margin-bottom: 18px;">
                        <label for="">Select ULB<span style="color: red;">*</span> </label>
                        <ng-select (change)="getSLFdetails($event)" placeholder="Select ULB" formControlName="ulb_id">
                            <ng-option value="" selected disabled>Select ULB</ng-option>
                            <ng-option [value]="u.ulb_id" *ngFor="let u of ulbData">{{u.ulb_name}}</ng-option>
                        </ng-select>
                        <div *ngIf="submittedregist && regist.ulb_id.errors">
                            <div *ngIf="regist.ulb_id.errors" class="errormessage"> Please Select ULB.
                            </div>
                        </div>
                    </div>
                    <div class="col-lg-3" style="margin-bottom: 18px;">
                        <label for="">Select SLF<span style="color: red;">*</span></label>
                        <ng-select placeholder="Select SLF" formControlName="slf_id"
                            (change)="getShgGropsReport($event)">
                            <ng-option value="" selected disabled>Select SLF</ng-option>
                            <ng-option [value]="s.slf_id" *ngFor="let s of slfData">{{s.slf_name}} -
                                ({{s.slf_id}})</ng-option>
                        </ng-select>
                        <div *ngIf="submittedregist && regist.slf_id.errors">
                            <div *ngIf="regist.slf_id.errors" class="errormessage"> Please Select SLF.
                            </div>
                        </div>
                    </div>
                    <div class="col-lg-3" style="margin-bottom: 18px;">
                        <label for="">Select SHG Group<span style="color: red;">*</span></label>
                        <ng-select placeholder="Select SHG Group" formControlName="shg_id"
                            (change)="getShgmembersReport($event)">
                            <ng-option value="" selected disabled>Select SHG Group</ng-option>
                            <ng-option [value]="s.shg_group_id" *ngFor="let s of shgGropsReport">{{s.shg_group_name}} -
                                ({{s.shg_group_id}})</ng-option>
                        </ng-select>
                        <div *ngIf="submittedregist && regist.shg_id.errors">
                            <div *ngIf="regist.shg_id.errors" class="errormessage"> Please Select SHG Group.
                            </div>
                        </div>
                    </div>
                    <div class="col-lg-3" style="margin-bottom: 18px;">
                        <label for="">Select SHG Member<span style="color: red;">*</span></label>
                        <ng-select placeholder="Select Member Id" formControlName="member_id"
                            (change)="getShgmemberdetails($event)">
                            <ng-option value="" selected disabled>Select SHG Member</ng-option>
                            <ng-option [value]="s.member_id" *ngFor="let s of shgmembersReport">{{s.member_name}} -
                                ({{s.member_id}})</ng-option>
                        </ng-select>
                        <div *ngIf="submittedregist && regist.member_id.errors">
                            <div *ngIf="regist.member_id.errors" class="errormessage"> Please Select SHG Member.
                            </div>
                        </div>
                    </div>
                    <div class="col-lg-3" style="margin-bottom: 18px;"
                        *ngIf="registrationform.get('are_you_shg').value == 'No'">
                        <label for="">Relation with SHG Member<span style="color: red;">*</span></label>
                        <ng-select placeholder="Relation with SHG " formControlName="relation_with_shg">
                            <ng-option value="" selected disabled>Relation with SHG </ng-option>
                            <ng-option [value]="s.name" *ngFor="let s of relationships">{{s.name}}</ng-option>
                        </ng-select>
                        <div *ngIf="submittedregist && regist.relation_with_shg.errors">
                            <div *ngIf="regist.relation_with_shg.errors" class="errormessage"> Please select Relation
                                with SHG Member.
                            </div>
                        </div>
                    </div>
                    <!-- <div class="col-lg-4" style="display: flex;flex-direction: row;gap: 8px;">
                    <div class="text-left">
                        <button mat-flat-button color="primary">Search</button>
                    </div>
                    <div class="text-left">
                        <button mat-flat-button color="primary">Reset</button>
                    </div>
                </div> -->
                </div>
                <h5>Personal Information</h5>
                <div class="row">
                    <!-- Full Name -->
                    <div class="col-lg-3">
                        <div class="custom-mat-input-wrapper">
                            <input type="text" class="custom-mat-input" placeholder=" " formControlName="full_name"
                                appTrimLeadingSpace [readOnly]="registrationform.get('are_you_shg').value == 'Yes'">
                            <label>Full Name<span style="color: red;">*</span></label>
                            <!-- <div class="invalid">
                                <span>Please Enter Full Name.</span>
                            </div> -->

                        </div>
                        <div *ngIf="submittedregist && regist.full_name.errors">
                            <div *ngIf="regist.full_name.errors" class="errormessage"> Please Enter Full Name.
                            </div>
                        </div>
                    </div>

                    <!-- Father's / Husband's Name -->
                    <div class="col-lg-3">
                        <div class="custom-mat-input-wrapper">
                            <input type="text" class="custom-mat-input" placeholder=" "
                                formControlName="father_or_husband_name" appTrimLeadingSpace>
                            <label>Father’s / Husband’s Name <span style="color: red;">*</span></label>
                        </div>
                        <div *ngIf="submittedregist && regist.father_or_husband_name.errors">
                            <div *ngIf="regist.father_or_husband_name.errors" class="errormessage"> Please Enter
                                Father’s / Husband’s Name.
                            </div>
                        </div>
                    </div>

                    <!-- Date of Birth -->
                    <div class="col-lg-3">
                        <div class="custom-mat-input-wrapper">
                            <input type="date" class="custom-mat-input" placeholder=" " formControlName="date_of_birth"
                                [max]="currentdate" [readOnly]="registrationform.get('are_you_shg').value == 'Yes'">
                            <label>Date of Birth<span style="color: red;">*</span></label>
                        </div>
                        <div *ngIf="submittedregist && regist.date_of_birth.errors">
                            <div *ngIf="regist.date_of_birth.errors" class="errormessage"> Please Enter Date of Birth.
                            </div>
                        </div>
                    </div>

                    <!-- Gender -->
                    <div class="col-lg-3">
                        <label>Gender<span style="color: red;">*</span></label>
                        <div style="display: flex;gap: 18px;">
                            <label><input type="radio" formControlName="gender" value="Male" [disabled]="radiobtn ==true">
                                Male</label>
                            <label><input type="radio" formControlName="gender" value="Female" [disabled]="radiobtn ==true">
                                Female</label>
                            <label><input type="radio" formControlName="gender" value="Other" [disabled]="radiobtn ==true">
                                Other</label>
                        </div>
                        <div *ngIf="submittedregist && regist.gender.errors">
                            <div *ngIf="regist.gender.errors" class="errormessage"> Please select gender.
                            </div>
                        </div>
                    </div>

                    <!-- Contact Number -->
                    <div class="col-lg-3">
                        <div class="custom-mat-input-wrapper">
                            <input type="text" class="custom-mat-input" placeholder=" " formControlName="contact_number"
                                maxlength="10" (input)="newnumaricprevent($event)" appTrimLeadingSpace >
                                <!-- [readOnly]="registrationform.get('are_you_shg').value == 'Yes'" -->
                            <label>Contact Number<span style="color: red;">*</span></label>
                        </div>
                        <div *ngIf="submittedregist && regist.contact_number.errors">
                            <div *ngIf="regist.contact_number.errors" class="errormessage"> Please Enter Contact Number.
                            </div>
                        </div>
                    </div>

                    <!-- Email ID -->
                    <div class="col-lg-3">
                        <div class="custom-mat-input-wrapper">
                            <input type="email" class="custom-mat-input" placeholder=" " formControlName="email"
                                appTrimLeadingSpace>
                            <label>Email ID<span style="color: red;">*</span></label>
                        </div>
                        <div *ngIf="submittedregist && regist.email.errors">
                            <div *ngIf="regist.email.errors" class="errormessage"> Please Enter Email ID.
                            </div>
                        </div>
                    </div>

                    <!-- Aadhaar Number -->
                    <div class="col-lg-3">
                        <div class="custom-mat-input-wrapper">
                            <input type="text" class="custom-mat-input" placeholder=" " formControlName="aadhaar_number"
                                maxlength="12" (input)="newnumaricprevent($event)" appTrimLeadingSpace>
                                <!-- [readOnly]="registrationform.get('are_you_shg').value == 'Yes'" -->
                            <label>Aadhaar Number<span style="color: red;">*</span></label>
                        </div>
                        <div *ngIf="submittedregist && regist.aadhaar_number.errors">
                            <div *ngIf="regist.aadhaar_number.errors" class="errormessage"> Please Enter Aadhaar Number.
                            </div>
                        </div>
                    </div>

                    <!-- Address -->
                    <div class="col-lg-3">
                        <!-- <div class="custom-mat-input-wrapper"> -->

                        <textarea class="custom-mat-input" rows="1" placeholder="Address*" formControlName="address"
                            appTrimLeadingSpace style="margin-top: 16px;"
                            [readOnly]="registrationform.get('are_you_shg').value == 'Yes'"></textarea>
                        <!-- <label>Address<span style="color: red;">*</span></label> -->
                        <!-- </div> -->
                        <div *ngIf="submittedregist && regist.address.errors">
                            <div *ngIf="regist.address.errors" class="errormessage"> Please Enter Address.
                            </div>
                        </div>
                    </div>
                    <div class="col-lg-12">
                        <div class="custom-mat-input-wrapper" style="text-align: center;">
                            <!-- <label>Upload Picture<span style="color: red;">*</span></label> -->
                            <input type="file" accept="image/*" #fileInput (change)="onImageChange($event)" hidden>
                            <!-- Clickable image that triggers file input -->
                            <img [src]=" photoPreview ? photoPreview :'assets/img/mepma/profile.png'" alt="Upload"
                                (click)="fileInput.click()" style="width: 100px; height: 100px; cursor: pointer; border: 2px dashed #ccc;
                                border-radius: 10px; padding: 10px;margin-bottom: 10px;" /><br>
                            <span> <strong>Upload Picture<span style="color: red;">*</span></strong> </span>
                        </div>
                    </div>
                </div>

                <hr>

                <!-- Educational Qualification -->
                <h5>Educational Qualification</h5>
                <div class="row">
                    <div class="col-lg-4">
                        <!-- <div class="custom-mat-input-wrapper">
                            <input type="text" class="custom-mat-input" placeholder=" "
                                formControlName="highest_qualification">
                            <label>Highest Qualification<span style="color: red;">*</span></label>
                        </div> -->
                        <!-- <label for="">Highest Qualification<span style="color: red;">*</span></label> -->
                        <ng-select placeholder="Highest Qualification" formControlName="highest_qualification"
                            style="margin-top: 16px;">
                            <ng-option value="" selected disabled>Highest Qualification</ng-option>
                            <ng-option [value]="s.value" *ngFor="let s of qualifications">{{s.label}}</ng-option>
                        </ng-select>
                        <div *ngIf="submittedregist && regist.highest_qualification.errors">
                            <div *ngIf="regist.highest_qualification.errors" class="errormessage"> Please select
                                qualification.
                            </div>
                        </div>
                    </div>
                    <div class="col-lg-4">
                        <div class="custom-mat-input-wrapper">
                            <input type="text" class="custom-mat-input" placeholder=" "
                                formControlName="year_of_passing" appTrimLeadingSpace>
                            <label>Year of Passing<span style="color: red;">*</span></label>
                        </div>
                        <div *ngIf="submittedregist && regist.year_of_passing.errors">
                            <div *ngIf="regist.year_of_passing.errors" class="errormessage"> Please Enter Year of
                                Passing.
                            </div>
                        </div>
                    </div>
                    <div class="col-lg-4">
                        <div class="custom-mat-input-wrapper">
                            <input type="text" class="custom-mat-input" placeholder=" "
                                formControlName="university_or_board" appTrimLeadingSpace>
                            <label>University / Board<span style="color: red;">*</span></label>
                        </div>
                        <div *ngIf="submittedregist && regist.university_or_board.errors">
                            <div *ngIf="regist.university_or_board.errors" class="errormessage"> Please Enter University
                                / Board.
                            </div>
                        </div>
                    </div>
                </div>

                <hr>

                <!-- Employment Details -->
                <h5>Employment Details</h5>
                <div class="row">
                    <div class="col-lg-3">
                        <label>Currently Employed<span style="color: red;">*</span></label>
                        <div style="display: flex;gap: 18px;">
                            <label><input type="radio" formControlName="currently_employed" value="Yes"> Yes</label>
                            <label><input type="radio" formControlName="currently_employed" value="No"> No</label>
                        </div>
                        <div *ngIf="submittedregist && regist.currently_employed.errors">
                            <div *ngIf="regist.currently_employed.errors" class="errormessage"> Please Select Currently
                                Employed.
                            </div>
                        </div>
                    </div>
                    <div class="col-lg-3" *ngIf="registrationform.get('currently_employed').value == 'Yes'">
                        <div class="custom-mat-input-wrapper">
                            <input type="text" class="custom-mat-input" placeholder=" "
                                formControlName="work_company_name" appTrimLeadingSpace>
                            <label>Company Name<span style="color: red;">*</span></label>
                        </div>
                        <div *ngIf="submittedregist && regist.work_company_name.errors">
                            <div *ngIf="regist.work_company_name.errors" class="errormessage"> Please Enter Company
                                Name.
                            </div>
                        </div>
                    </div>
                    <div class="col-lg-3" *ngIf="registrationform.get('currently_employed').value == 'Yes'">
                        <div class="custom-mat-input-wrapper">
                            <input type="text" class="custom-mat-input" placeholder=" " formControlName="designation"
                                appTrimLeadingSpace>
                            <label>Designation<span style="color: red;">*</span></label>
                        </div>
                        <div *ngIf="submittedregist && regist.designation.errors">
                            <div *ngIf="regist.designation.errors" class="errormessage"> Please Enter Designation.
                            </div>
                        </div>
                    </div>
                    <div class="col-lg-3" *ngIf="registrationform.get('currently_employed').value == 'Yes'">
                        <div class="custom-mat-input-wrapper">
                            <input type="text" class="custom-mat-input" placeholder=" "
                                formControlName="work_experience">
                            <label>Work Experience (Years)<span style="color: red;">*</span></label>
                        </div>
                        <div *ngIf="submittedregist && regist.work_experience.errors">
                            <div *ngIf="regist.work_experience.errors" class="errormessage"> Please Enter Work
                                Experience (Years).
                            </div>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-12" style="text-align: center;margin-top: 18px;" *ngIf="!showOtp">
                        <button class="reg-btn" style="background: #3f51b5;border:1px solid #3f51b5;" type="button"
                            (click)="verifyOtp()"> Verify OTP</button>
                    </div>
                    <div class="col-12" *ngIf="showOtp" style=" text-align: center;">
                        <div style="margin-bottom: 12px;">
                            <!-- <div> Please enter the verification
                                code sent to mobile number
                                {{this.registrationform.value.contact_number}}
                            </div> -->
                            <div> Please Submit 
                            </div>
                        </div>
                        <div>
                            <!-- <label for="">Please enter the verification code sent to mobile number
                                {{this.registrationform.value.contact_number}}</label> -->
                            <input type="text" readonly class="custom-mat-input" placeholder="Enter OTP" formControlName="otp"
                                appTrimLeadingSpace style="width: 20%;">
                            <!-- <label>Enter OTP<span style="color: red;">*</span></label> -->
                        </div>
                        <div *ngIf="submittedregist && regist.otp.errors">
                            <div *ngIf="regist.otp.errors" class="errormessage"> Please Enter OTP.
                            </div>
                        </div>
                    </div>

                    <div class="col-12" *ngIf="showOtp && registrationform.get('are_you_shg').value == 'No'"
                        style=" text-align: center;">
                        <div style="margin-bottom: 12px;">
                            <div> Please enter the verification
                                code sent to mobile number
                                {{memberNo}}
                            </div>
                        </div>
                        <div>
                            <!-- <label for="">Please enter the verification code sent to mobile number
                                {{this.registrationform.value.contact_number}}</label> -->
                            <input type="text" readonly class="custom-mat-input" placeholder="Enter OTP"
                                formControlName="shg_otp" appTrimLeadingSpace style="width: 20%;">
                            <!-- <label>Enter OTP<span style="color: red;">*</span></label> -->
                        </div>

                        <div *ngIf="submittedregist && regist.otp.errors">
                            <div *ngIf="regist.otp.errors" class="errormessage"> Please Enter OTP.
                            </div>
                        </div>

                    </div>

                    <div class="col-12" style="text-align: center;margin-top: 18px;" *ngIf="showOtp">
                        <button class="reg-btn"> Sumbit </button>
                    </div>
                </div>

            </form>
        </mat-card-content>
    </mat-card>
</div>


<div *ngIf="showloader" class="overlap">
    <div class="loader"></div>
</div>